import { motion } from 'framer-motion';
import Section from '../components/Section';
import ContactForm from '../components/ContactForm';
import PageHero from '../components/PageHero';
import SurfaceCard from '../components/SurfaceCard';
import { SF_UI } from '../components/ui/tokens';

const ContactPage = () => {
  return (
    <>
      <PageHero
        eyebrow="Support"
        title="Contact Us"
        subtitle="Have questions or want to learn more about SportsFuture? We'd love to hear from you."
      />
      <Section bgColor={SF_UI.sectionBand} className="pt-12">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.45 }}
          className="max-w-2xl mx-auto"
        >
          <SurfaceCard>
            <h2 className="text-2xl font-bold mb-6 text-gray-900">Get In Touch</h2>
            <ContactForm />
          </SurfaceCard>
        </motion.div>
      </Section>
    </>
  );
};

export default ContactPage;